import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { SESSION_ACTION_TYPE } from "@obg/ngx.core";
import { isLocalStorageSupported } from "@obg/ngx.global";
import { map } from "rxjs/operators";

import { HIDE_KYC_NOTIFICATION_STORAGE_KEY } from "./header.container.const";

@Injectable()
export class HeaderEffect {
	removeHideKycNotification$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType(
					SESSION_ACTION_TYPE.loginSuccess,
					SESSION_ACTION_TYPE.loginWithVerificationCodeSuccess,
					SESSION_ACTION_TYPE.loginWithPersonalNumberSuccess,
					SESSION_ACTION_TYPE.loginWithTokenSuccess,
					SESSION_ACTION_TYPE.logoutSuccess,
					SESSION_ACTION_TYPE.logoutFail
				),
				map(() => {
					if (isLocalStorageSupported()) {
						localStorage.removeItem(HIDE_KYC_NOTIFICATION_STORAGE_KEY);
					}
				})
			),
		{ dispatch: false }
	);

	constructor(private actions$: Actions) {}
}
